<div class="container-fluid">
    <mat-divider class="mb-4"></mat-divider>
    <div class="row">
        <h3>Listado de Activos</h3>
    </div>
    <div *ngFor="let activoForm of formArray.controls; let i = index">
        <form [formGroup]="activoForm" class="row" (ngSubmit)="onSubmit()">
            <div class="row">

                <mat-form-field appearance="outline" class="col-md-3">
                    <mat-label>Tipo de Activo</mat-label>
                <mat-select formControlName="tipoActivo" (valueChange)="tipoActivoChange($event, i)">
                    <mat-option *ngFor="let tipo of getTipoActivo()" [value]="tipo">{{ tipoActivos[tipo]
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
        
            <mat-form-field appearance="outline" class="col-md-3" *ngIf="activoForm.get('tipoActivo')?.value != 'BienesRaices' && activoForm.get('tipoActivo')?.value != 'Vehiculos'">
                <mat-label>Detalle</mat-label>
                <input matInput formControlName="detalle" placeholder="Detalle">
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-md-4" *ngIf="activoForm.get('tipoActivo')?.value == 'BienesRaices'">
                <mat-label>Tipo de Bienes Raíces</mat-label>
                <mat-select formControlName="tipoBienesRaices">
                    <mat-option *ngFor="let tipo of getTipoBienesRaices()" [value]="tipo">{{ tipoBienesRaices[tipo]}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-md-3" *ngIf="activoForm.get('tipoActivo')?.value == 'Vehiculos'">
                <mat-label>Tipo de Vehículo</mat-label>
                <mat-select formControlName="tipoVehiculo"  >
                    <mat-option *ngFor="let tipo of getTipoVehiculo()" [value]="tipo">{{ tipoVehiculos[tipo]}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-md-3" *ngIf="activoForm.get('tipoActivo')?.value == 'Vehiculos'">
                <mat-label>Marca</mat-label>
                <input matInput type="text" formControlName="Marca" placeholder="Marca">
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-md-3" *ngIf="activoForm.get('tipoActivo')?.value == 'Vehiculos'">
                <mat-label>Modelo</mat-label>
                <input matInput type="text" formControlName="Modelo" placeholder="Modelo">
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="col-md-3" *ngIf="activoForm.get('tipoActivo')?.value == 'Vehiculos'">
                <mat-label>Año</mat-label>
                <input matInput type="text" formControlName="Anio" placeholder="Año">
            </mat-form-field>


            <mat-form-field appearance="outline" class="col-md-3">
                <mat-label>Valor Comercial</mat-label>
                <input *ngIf="activoForm.get('tipoActivo')?.value != 'BienesRaices'; else usarUF" matInput currencyMask type="text" formControlName="valorComercial" placeholder="$" step="1">
                <ng-template #usarUF>
                    <input matInput type="text" formControlName="valorComercial" placeholder="UF">
                    <span class="UFSufix" *ngIf="activoForm.get('valorComercial')?.value">UF</span>
                </ng-template>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-md-2" *ngIf="activoForm.get('tipoActivo')?.value == 'Inversiones'">
                <mat-label>Valor de Cuota</mat-label>
                <input matInput currencyMask type="text" formControlName="valorCuota" placeholder="$" step="1">
             </mat-form-field>
            <div class="row" *ngIf="activoForm.get('tipoActivo')?.value == 'BienesRaices' || activoForm.get('tipoActivo')?.value == 'Vehiculos'; else otherActivosTemplate">
                 <mat-form-field appearance="outline" class="col-md-2">
                     <mat-label>{{  activoForm.get('textoRol')?.value }}</mat-label>
                     <input matInput formControlName="rolPatente" placeholder="{{activoForm.get('textoRol')?.value}}">
                    </mat-form-field>

                    <mat-checkbox class="col-md-2" formControlName="prendaHipoteca" (change)="prendaHipotecaChange($event.checked, i)">{{activoForm.get('textoPreda')?.value}}</mat-checkbox>

                <mat-form-field appearance="outline" class="col-md-2">
                    <mat-label>Saldo de Deuda</mat-label>
                    <input *ngIf="activoForm.get('tipoActivo')?.value != 'BienesRaices'; else usarUFDeuda" matInput currencyMask type="text" formControlName="saldoDeuda" placeholder="$" step="1">
                    <ng-template #usarUFDeuda>
                      <input matInput type="text" formControlName="saldoDeuda" placeholder="Saldo de Deuda">
                      <span class="UFSufix" *ngIf="activoForm.get('saldoDeuda')?.value">UF</span>
                    </ng-template>
                </mat-form-field>
                
                <mat-form-field appearance="outline" class="col-md-2">
                    <mat-label>Valor de Cuota</mat-label>
                    <input matInput currencyMask type="text" formControlName="valorCuota" placeholder="$" step="1">
                </mat-form-field>
                
                <mat-form-field appearance="outline" class="col-md-2" >
                    <mat-label>Comentario</mat-label>
                    <input matInput formControlName="comentario" placeholder="Comentario">
                </mat-form-field>
            </div>
        
            <mat-form-field appearance="outline" class="col-md-2" *ngIf="activoForm.get('tipoActivo')?.value == 'Inversiones'">
                <mat-label>Saldo de Deuda</mat-label>
                <input matInput currencyMask type="text" formControlName="saldoDeuda" placeholder="$" step="1">
            </mat-form-field>
            <ng-template #otherActivosTemplate>
                <mat-form-field appearance="outline" class="col-md-2">
                <mat-label>Comentario</mat-label>
                <input matInput formControlName="comentario" placeholder="Comentario">
            </mat-form-field>
            </ng-template>
        </div>
            
            <button mat-icon-button color="warn" type="button" (click)="eliminarActivo(i)" [disabled]="formFirmado" style="margin: auto;">
                <mat-icon>delete</mat-icon>
            </button>
            
            <mat-divider class="mb-4"></mat-divider>
        </form>
    </div>
    
    <div class="row">
        <div class="mt-4">
            <button mat-raised-button color="accent" type="button" class="ml1 mr1 fl" (click)="agregarActivo(null)"><mat-icon >add_circle</mat-icon> Agregar Activo</button>
            <button id="actovosSiguiente" mat-raised-button color="primary" class="ml1 mr1 fr" (click)="onSubmit()">Siguiente</button>
            <button id="activosVolver" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="volver()">Volver</button>
        </div>
    </div>
</div>
